module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "align-self-stretch pb-5",
    attrs: {
      "xs12": "",
      "fill-height": ""
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide-x-transition",
      "mode": "out-in",
      "appear": ""
    }
  }, [(_vm.tab === 1) ? _c('tud-my-addresses') : _vm._e(), _vm._v(" "), (_vm.tab === 2) ? _c('tud-user-map-mine') : _vm._e(), _vm._v(" "), (_vm.tab === 3) ? _c('tud-user-map-all') : _vm._e(), _vm._v(" "), (_vm.tab === 4) ? _c('tud-all-addresses') : _vm._e()], 1), _vm._v(" "), _c('v-bottom-nav', {
    staticClass: "primary",
    attrs: {
      "shift": "",
      "value": "true"
    }
  }, [_c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 1
    },
    nativeOn: {
      "click": function($event) {
        _vm.tab = 1
      }
    }
  }, [_c('span', [_vm._v("Adresele mele")]), _vm._v(" "), _c('v-icon', [_vm._v("person_pin_circle")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 2
    },
    nativeOn: {
      "click": function($event) {
        _vm.tab = 2
      }
    }
  }, [_c('span', [_vm._v("Adr. mele")]), _vm._v(" "), _c('v-icon', [_vm._v("map")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 3
    },
    nativeOn: {
      "click": function($event) {
        _vm.tab = 3
      }
    }
  }, [_c('span', [_vm._v("Toate adr")]), _vm._v(" "), _c('v-icon', [_vm._v("map")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 4
    },
    nativeOn: {
      "click": function($event) {
        _vm.tab = 4
      }
    }
  }, [_c('span', [_vm._v("Toate adresele")]), _vm._v(" "), _c('v-icon', [_vm._v("place")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fb74a03"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Index.vue
// module id = 595
// module chunks = 12